import React from 'react';
import { ComingSoonPage } from './ComingSoonPage';

function SsoPage() {
  return (
    <ComingSoonPage
      label="Access"
      title="Single sign-on"
      description="Enterprise identity provider integration."
      planned={[
        'OIDC provider configuration (Okta, Google Workspace, Azure AD)',
        'Enforced SSO login for organisation members',
        'Group-to-role mapping for automatic access provisioning',
      ]}
    />
  );
}

export { SsoPage };
